import { Injectable } from '@angular/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import {
  ModifyRuleComponent,
  RuleComponentConfig,
} from './modify-rule.component';
import { Rule } from '../../../models/rule.model';

@Injectable({
  providedIn: 'root',
})
export class RuleDialogService {
  constructor(private dialogService: DialogService) {}

  /**
   * Opens the rule dialog for creating a new rule
   * @param showDrafts Whether to show the drafts functionality
   * @returns DynamicDialogRef for the opened dialog
   */
  openCreateRuleDialog(showDrafts: boolean = true): DynamicDialogRef | null {
    const config: RuleComponentConfig = {
      mode: 'create',
      showDrafts: showDrafts,
    };

    return this.dialogService.open(ModifyRuleComponent, {
      header: 'Créer une nouvelle règle',
      width: '90vw',
      height: '90vh',
      contentStyle: { overflow: 'auto' },
      baseZIndex: 10000,
      maximizable: true,
      closable: true,
      modal: true,
      data: config,
    });
  }

  /**
   * Opens the rule dialog for editing an existing rule
   * @param rule The rule to edit
   * @returns DynamicDialogRef for the opened dialog
   */
  openEditRuleDialog(rule: Rule): DynamicDialogRef | null {
    const config: RuleComponentConfig = {
      rule: rule,
      mode: 'edit',
      showDrafts: false,
    };

    return this.dialogService.open(ModifyRuleComponent, {
      header: 'Modifier la règle',
      width: '90vw',
      height: '90vh',
      contentStyle: { overflow: 'auto' },
      baseZIndex: 10000,
      maximizable: true,
      closable: true,
      modal: true,
      data: config,
    });
  }

  /**
   * Opens the rule dialog for creating a new rule without drafts (simplified version)
   * @returns DynamicDialogRef for the opened dialog
   */
  openSimpleCreateRuleDialog(): DynamicDialogRef | null {
    return this.openCreateRuleDialog(false);
  }
}
